export const light = {
  body: '#edf2f7',
  text: '#363537',
  header: {
    title: '#000',
    subtitle: 'rgba(0, 0, 0, 0.8)',
  },
  markdown: {
    background: 'rgba(0, 0, 0, 0.08)',
    color: '#000',
    border: '#334f72',
  },
  previewer: {
    background: '#fff',
    color: '#000',
    links: 'rgb(60, 86, 226)',
    code: '#dde1e6',
  },
}

export const dark = {
    body: '#222',
  text: '#FAFAFA',
  header: {
    title: '#fff',
    subtitle: 'rgba(250, 250, 250, 0.8)',
  },
  markdown: {
    background: '#363537',
    color: '#fff',
    border: '#828282',
  },
  previewer: {
    background: '#222',
    color: '#fff',
    links: 'rgb(135, 206, 235)',
    code: '#363537',
  },
}